import React from 'react'
import { connect } from 'react-redux';
import { ICategory } from '../../../../Utils/types';
import {
  Input,
  Typography,
  Button
} from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { localization } from '../../../../Utils/Localization/localization';
import { languageSelector } from '../../../../Redux/Reducers/settingsReducer';
import {
  addNewCategory,
  getCategories,
  removeCategory,
  patchCategory,
  categoriesSelector
} from '../../../../Redux/Reducers/categoriesReducer'
import {
  userLevelSelector
} from '../../../../Redux/Reducers/userReducer'
import classes from './CategoriesPage.module.scss';
import confirm from 'antd/lib/modal/confirm';

interface StateProps {
  categories: ICategory[],
  language: string,
  level: number
}
interface DispatchProps {
  addNewCategory: (value: string) => void,
  getCategories: () => void,
  removeCategory: (id: number) => void,
  patchCategory: (newName: string, id: number) => void
}
interface Props extends StateProps, DispatchProps { }

function CategoriesPage(props: Props) {
  const [newCategoryName, setNewCategoryName] = React.useState('');
  const permissionLevel = props.level >= 2;

  React.useEffect(() => {
    props.getCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleNewCategory() {
    props.addNewCategory(newCategoryName);
    setNewCategoryName('');
  }
  function handleOnChange(newName: string, id: number) {
    props.patchCategory(newName, id);
  }

  function showDeleteConfirm(id: number) {
    confirm({
      title: 'Are you sure delete this task?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        props.removeCategory(id);
      },
      onCancel() { },
    });
  }

  return (
    <div className={classes.CategoryesPage}>
      <h2>{localization('categoryes', props.language)}</h2>
      <ul>
        {
          props.categories
          && props.categories.map((item) => {
            return (
              <li className={classes.Category} key={item.id}>
                <Typography.Paragraph
                  editable={permissionLevel && { onChange: (str) => handleOnChange(str, item.id) }}
                >
                  {item.name}
                </Typography.Paragraph>
                <Button
                  onClick={() => showDeleteConfirm(item.id)}
                  disabled={!permissionLevel}
                  type={'danger'}
                >
                  {localization('delete', props.language)}
                </Button>
              </li>
            );
          })
        }
        <li key={'new category'} className={classes.NewCategory}>
          <Input
            placeholder={localization('newCategory', props.language)}
            onChange={(e: any) => permissionLevel && setNewCategoryName(e.target.value)}
            value={newCategoryName}
          />
          <Button
            type={'primary'}
            onClick={handleNewCategory}
            disabled={!permissionLevel}
          >
            {localization('add', props.language)}
          </Button>
        </li>
      </ul>
    </div>
  );
}

function mapStateToProps(state: any) {
  return {
    categories: categoriesSelector(state),
    language: languageSelector(state),
    level: userLevelSelector(state)
  }
}
const mapDispatchToProps = {
  addNewCategory,
  getCategories,
  removeCategory,
  patchCategory
}

const ConnectedCategoriesPage = connect(mapStateToProps, mapDispatchToProps)(CategoriesPage);
export { ConnectedCategoriesPage as CategoriesPage };